// S2 · Calibration tab (spec 04 §4 S2, slice 04-C-2 — added ONLY now that
// `calibration_records` exists, per the §4 tab rule; Genealogy stays absent
// until C-3). The §5 e21 list filtered to this work order: what each barrel's
// machine claimed vs what was measured — the measured value being the only
// number costing and inventory ever used (D-025). Offered only to holders of
// `production.telemetry.read` (the e21 fence — a tab that 403s is worse than
// an absent one).

import { useTranslation } from "react-i18next";
import { EmptyState, ErrorState, TableSkeleton } from "../../../../components/states";
import { requestIdOf } from "../../../../lib/request";
import { useCalibrationRecords } from "../hooks/production-queries";
import { RecordsTable } from "../screens/calibration";

export function CalibrationTab({ workOrderId }: { workOrderId: string }) {
  const { t, i18n } = useTranslation();
  const records = useCalibrationRecords({ work_order_id: workOrderId }, workOrderId.length > 0);

  if (records.isPending) {
    return <TableSkeleton rows={3} label={t("production.common.loading")} />;
  }
  if (records.error) {
    return (
      <ErrorState
        title={t("production.calibration.tabError")}
        detail={records.error instanceof Error ? records.error.message : undefined}
        retryLabel={t("production.common.retry")}
        onRetry={() => void records.refetch()}
        requestId={requestIdOf(records.error)}
        requestIdLabel={t("production.common.requestId")}
      />
    );
  }
  if (records.data.items.length === 0) {
    return (
      <EmptyState
        title={t("production.calibration.tabEmptyTitle")}
        body={t("production.calibration.tabEmptyBody")}
      />
    );
  }
  return <RecordsTable records={records.data.items} locale={i18n.language} />;
}
